import { MAXIMUM_VIEW_SIZE } from 'common/constants'

export const getPaginationProps = ({
  page,
  quantity,
  t,
  onPageChange,
  term,
  filters,
  viewSize = MAXIMUM_VIEW_SIZE,
  breadcrumbs
}) => ({
  currentPage: page.page,
  total: Math.ceil(quantity / viewSize),
  translations: {
    prevButtonCaption: t('lister.pager.prev'),
    nextButtonCaption: t('lister.pager.next')
  },
  onChange: onPageChange,
  getPath: pageNum => {
    const searchParams = new URLSearchParams()
    // need to handle also noJs .env
    if (pageNum) searchParams.append('currentPage', pageNum)
    if (term) searchParams.append('text', term)
    if (filters.active) {
      const activeFiltersArr = Object.entries(filters.active)
      const filterKeys = []
      activeFiltersArr.forEach(([key, val]) => {
        filterKeys.push(key)
        searchParams.append(
          key,
          Object.entries(val).map(([_, activeFilter]) => activeFilter.value)
        )
      })
      if (filterKeys.length > 0) searchParams.append('filterKeys', filterKeys)
    }

    if (isFirstPageWithNoParams(pageNum, searchParams)) return breadcrumbs?.collection?.at(-1).link || '?'
    return `?${searchParams.toString()}`
  },
  keyword: 'currentPage'
})

function isFirstPageWithNoParams(pageNum, searchParams) {
  return pageNum === 1 && [...searchParams.values()]?.length === 1 && !!searchParams.get('currentPage')
}
